import { Component, OnInit, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import { AccreditationSegment } from 'src/app/common/common-product/models/product-short.model';
import { Contract } from 'src/app/snatch/models/contract.model';

@Component({
  selector: 'leap-how-to-access',
  templateUrl: './how-to-access.component.html',
  styleUrls: ['./how-to-access.component.less', '../../styles/tab-content.less'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HowToAccessComponent implements OnInit {

  @Input() sellerRole: string;
  @Input() sellerAccreditationStatus: string;
  @Input() trainerRequirements: string;
  @Input() accreditationRequirements: string;
  @Input() accreditationProcess: string;
  @Input() examInformation: string;
  @Input() accreditationSegments: AccreditationSegment[];

  @Input() segmentsMapper: Map<string, Contract>;

  @Output() getAccess: EventEmitter<string> = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

}
